import { render, staticRenderFns } from "./browseHistory.vue?vue&type=template&id=32ef12ea&scoped=true"
import script from "./browseHistory.vue?vue&type=script&lang=js"
export * from "./browseHistory.vue?vue&type=script&lang=js"
import style0 from "./browseHistory.vue?vue&type=style&index=0&id=32ef12ea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ef12ea",
  null
  
)

export default component.exports